<template>
  <div class="dropdown d-inline-block" v-if="optionsDropdownItems.length">
    <a class="dropdown-ellipses dropdown-toggle" data-toggle="dropdown" href="#!" role="button">
      <i class="fe fe-more-vertical"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-for="item in optionsDropdownItems"
        :key="item.text"
        @click="item.action"
        class="dropdown-item"
        href="javascript:;"
      >
        <span :class="item.type">{{ item.text }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const CompanyModule = createNamespacedHelpers('company')

// @group Keywords
/**
 * This component is the vertical ellipses at the right side of Keyword Table.
 * When clicked it shows additional actions.
 * */
export default {
  name: 'KeywordListDropdown',
  props: {
    // The selected Keyword from the table.
    keyword: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...CompanyModule.mapGetters(['selectIsPermitted']),
    canEditKeywords() {
      return this.selectIsPermitted('keywordsWriteAccess')
    },
    optionsDropdownItems() {
      // Both conditions belong here so the trigger's v-if on this list is the single
      // source of truth: a keyword with no company has no actions either, and the
      // ellipsis must not render for it.
      if (!this.canEditKeywords || !this.keyword.company) return []

      return [
        {
          type: 'text-primary',
          text: 'Edit',
          action: () => {
            // Notifies parent component to navigate to the edit page
            // @arg No parameters
            this.$emit('edit')
          }
        },
        {
          type: 'text-danger',
          text: 'Archive',
          action: () => {
            // Notifies parent component to archive the selected keyword
            // @arg No parameters
            this.$emit('archive')
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
